import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import { text2XL } from '@styles/fonts'
import styled from 'styled-components'

export const Group = styled.div`
  margin-bottom: 52px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const GroupHeading = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;

  > div {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  @media ${DEVICES.mobile} {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
  }
`

export const Note = styled.p`
  padding-top: 16px;
  display: block;
  font-size: 14px;
  color: ${COLORS.grey[60]};
`

export const Title = styled.h2`
  ${text2XL};
  color: ${COLORS.suburbHeading};

  @media ${DEVICES.mobile} {
    text-align: center;
  }
`

export const ChartLegend = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;

  span {
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    color: ${COLORS.white};
    border-radius: 20px;
    padding: 7px 20px;

    &.house {
      background-color: ${COLORS.cobalt.base};
    }

    &.unit {
      background-color: ${COLORS.black};
    }
  }
`
